import {Box, Typography} from "@mui/material";
import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import gal1 from "../../images/tours/gallery/gal1.JPG";
import gal2 from "../../images/tours/gallery/gal2.JPG";
import gal3 from "../../images/tours/gallery/gal3.JPG";
import gal4 from "../../images/tours/gallery/gal4.JPG";
import gal5 from "../../images/tours/gallery/gal5.JPG";
import gal6 from "../../images/tours/gallery/gal6.JPG";
import gal7 from "../../images/tours/gallery/gal7.JPG";
import gal8 from "../../images/tours/gallery/gal8.PNG";
import gal9 from "../../images/tours/gallery/gal9.PNG";
import gal10 from "../../images/tours/gallery/gal10.PNG";
import gal11 from "../../images/tours/gallery/gal11.PNG";
import {useLanguage} from "../../LanguageContext";
import {sectionTitle} from "../styles/CommonStyles";


const images = [
    gal1,
    gal2,
    gal3,
    gal4,
    gal5,
    gal6,
    gal7,
    gal8,
    gal9,
    gal10,
    gal11,
];

const GalleryHeader = ({t}) => (
    <Box
        sx={{
            textAlign: 'center',
            pb: '24px',
            pt: '24px'
        }}>
        <Typography
            sx={{
                ...sectionTitle,
                ...({color: 'white'})
            }}
        >
            {t('gallery_title')}
        </Typography>
    </Box>
);


const GroupTourGallerySection = () => {
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                width: "100%",
                backgroundColor: "#2C2C2C",
                paddingTop: {xs: '30px', md: '20px'},
                // paddingBottom: {xs: '30px'},
            }}
        >
            <GalleryHeader t={t}/>
            <Box sx={{
                height: '76vh',
                width: "100%",
                mx: "auto",
                position: "relative",
                p: 2,
                borderRadius: "0px",
                overflow: "hidden",
            }}>
                <Swiper
                    modules={[Pagination, Autoplay, Navigation]}
                    spaceBetween={20}
                    slidesPerView={1}
                    breakpoints={{
                        640: { slidesPerView: 1, spaceBetween: 20 },
                        960: { slidesPerView: 2, spaceBetween: 30 },
                        1280: { slidesPerView: 3, spaceBetween: 30 },
                    }}
                    loop={true}
                    centeredSlides={false}
                    autoplay={{ delay: 3000 }}
                    initialSlide={1}
                    navigation
                    pagination={{
                        clickable: true,
                        justifyContent: "center",
                        el: ".custom-swiper-pagination"  // Attach pagination manually
                    }}
                >
                    {images.map((item, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ position: "relative" }}>
                                <Box
                                    component="img"
                                    src={item}
                                    alt={`Slide ${index + 1}`}
                                    sx={{
                                        width: '100%',
                                        maxHeight: { xs: "70vh", sm: "70vh", md: "70vh" },
                                        minHeight: { xs: "70vh", sm: "70vh", md: "70vh" },
                                        objectFit: "cover",
                                        borderRadius: "0px",
                                    }}
                                />
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Pagination below the Swiper */}
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", // Ensures vertical alignment
                    mt: 2, // Adjust space between Swiper and pagination
                    "& .custom-swiper-pagination": {
                        display: "flex",
                        justifyContent: "center", // Centers bullets horizontally
                        gap: "8px", // Adds spacing between bullets
                    },
                    "& .swiper-pagination-bullet": {
                        backgroundColor: "#ffffff",
                        opacity: 1,
                    },
                    "& .swiper-pagination-bullet-active": {
                        backgroundColor: "#D36E4B",
                    },
                }}>
                    <div className="custom-swiper-pagination"></div> {/* Pagination */}
                </Box>
            </Box>
        </Box>
    );
}

export default GroupTourGallerySection;
